// Components/PrivateRoute.jsx
import { Navigate } from 'react-router-dom';
import LegalComplianceEnforcer from './LegalComplianceEnforcer';
import { useState, useEffect, cloneElement } from 'react';
import { API_ENDPOINTS } from '../Config/api';
import { fetchWithAuth } from '../Utils/fetchWithAuth';

export default function PrivateRoute({ children }) {
  const accessToken = sessionStorage.getItem('access_token');
  const isAuthenticated = !!accessToken;
  const [visibilityChecked, setVisibilityChecked] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      // Decode token payload for UI hints only (e.g. impersonation banner).
      // This is NOT a security decision — all auth is enforced server-side.
      let impersonating = false;
      try {
        const token = sessionStorage.getItem('access_token');
        if (token) {
          const parts = token.split('.');
          if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1]));
            impersonating = !!payload.is_impersonating;
          }
        }
      } catch {
        // Malformed token — treat as non-impersonating
      }
      setIsImpersonating(impersonating);

      // Se utente è in impersonation (SSO), salta il controllo visibilità
      if (impersonating) {
        setIsVisible(true);
        setVisibilityChecked(true);
        return;
      }

      // Fetch visibility
      fetchWithAuth(API_ENDPOINTS.aziendaDettagli)
        .then(res => res.json())
        .then(data => {
          setIsVisible(data.visibile_a_azienda || false);
          setVisibilityChecked(true);
        })
        .catch(err => {
          console.error('Errore nel controllo visibilità:', err);
          setVisibilityChecked(true);
          setIsVisible(false);
        });
    } else {
      setVisibilityChecked(true);
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (!visibilityChecked) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-white">
        <div className="flex items-center gap-3">
          <svg className="w-6 h-6 text-yellow-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="text-gray-800 font-medium animate-pulse text-2xl">Controllo accesso...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <LegalComplianceEnforcer />
      {typeof children?.type === 'function' || typeof children?.type === 'object'
        ? cloneElement(children, { isVisible: isVisible || isImpersonating })
        : children}
    </>
  );
}
